import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';

import PatientsDialogListEmpty from './PatientsDialogListEmpty';
import PatientsDialogListItem from './PatientsDialogListItem';

const styles = theme => ({
  root: {
    width: '100%',
    overflow: 'hidden',
  },
  table: {
    minWidth: 500,
    [theme.breakpoints.down('xs')]: {
      minWidth: 0,
    },
  },
});

const PatientsDialogList = ({
  patients,
  onPatientClick,
  loading,
  classes,
}) => (
  <div className={classes.root}>
    {(patients.length === 0 && loading === 0) ? (
      <PatientsDialogListEmpty />
    ) : (
      <Table className={classes.table}>
        <TableBody>
          {patients.map(patient => (
            <PatientsDialogListItem
              key={patient['Record Number']}
              {...patient}
              {...onPatientClick ? { onClick: () => { onPatientClick(patient); } } : {}}
            />
          ))}
        </TableBody>
      </Table>
    )}
  </div>
);

PatientsDialogList.propTypes = {
  patients: PropTypes.arrayOf(PropTypes.shape({
    'Record Number': PropTypes.number.isRequired,
  })).isRequired,
  onPatientClick: PropTypes.func,
  loading: PropTypes.number.isRequired,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    table: PropTypes.string.isRequired,
  }).isRequired,
};

PatientsDialogList.defaultProps = {
  onPatientClick: null,
};

export default withStyles(styles)(PatientsDialogList);



// WEBPACK FOOTER //
// ./src/components/patient/PatientsDialog/PatientsDialogList.js